import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import HousePrice from "./pages/HousePrice";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Register from "./pages/Register";

import Dashboard from "./components/dashboard/houseSystem/dashboard/Dashboard";
import SearchBorrower from "./components/dashboard/houseSystem/searchBorrower/SearchBorrower";
import AddEditBorrower from "./components/dashboard/houseSystem/addEditBorrower/AddEditBorrower";
import ViewBorrower from "./components/dashboard/houseSystem/viewBorrower/ViewBorrower";
import NewInvoice from "./components/dashboard/houseSystem/newInvoice/NewInvoice";
import SearchInvoices from "./components/dashboard/houseSystem/searchInvoices/SearchInvoices";
import HousePlans from "./components/dashboard/houseSystem/housePlans/HousePlans";

import SearchExpenses from "./components/dashboard/expenses/searchExpenses/SearchExpenses";
import AddEditExpenses from "./components/dashboard/expenses/addEditExpenses/AddEditExpenses";
import ViewExpenses from "./components/dashboard/expenses/viewExpenses/ViewExpenses";
import AddEditCaExpenses from "./components/dashboard/expenses/addEditCaExpenses/AddEditCaExpenses";
import SearchCaExpenses from "./components/dashboard/expenses/searchCaExpenses/SearchCaExpenses";
import SearchCategories from "./components/dashboard/expenses/searchCategories/SearchCategories";

import AddEditProducts from "./components/dashboard/store/addEditProducts/AddEditProducts";
import SearchProduct from "./components/dashboard/store/searchProduct/SearchProduct";
import SearchOrders from "./components/dashboard/store/searchOrders/SearchOrders";

import Formulas from "./components/dashboard/settings/formulas/Formulas";
import EditHouseAgreement from "./components/dashboard/settings/editHouseAgreement/EditHouseAgreement";
import General from "./components/dashboard/settings/general/General";
import AllBanners from "./components/dashboard/settings/allBanners/AllBanners";
import PrintInvoice from "./components/dashboard/settings/printInvoice/PrintInvoice";
import Taxnomies from "./components/dashboard/settings/taxnomies/Taxnomies";

import YourProfile from "./components/dashboard/users/yourProfile/YourProfile";
import UpdatePassword from "./components/dashboard/users/updatePassword/UpdatePassword";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/housePrice" element={<HousePrice />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/searchBorrower" element={<SearchBorrower />} />
      <Route path="/addEditBorrower" element={<AddEditBorrower />} />
      <Route path="/viewBorrower" element={<ViewBorrower />} />
      <Route path="/newInvoice" element={<NewInvoice />} />
      <Route path="/searchInvoices" element={<SearchInvoices />} />
      <Route path="/housePlans" element={<HousePlans />} />

      <Route path="/searchExpenses" element={<SearchExpenses />} />
      <Route path="/addEditExpenses" element={<AddEditExpenses />} />
      <Route path="/viewExpenses" element={<ViewExpenses />} />
      <Route path="/addEditCaExpenses" element={<AddEditCaExpenses />} />
      <Route path="/searchCaExpenses" element={<SearchCaExpenses />} />
      <Route path="/searchCategory" element={<SearchCategories />} />

      <Route path="/addEditProducts" element={<AddEditProducts />} />
      <Route path="/searchProduct" element={<SearchProduct />} />
      <Route path="/searchOrders" element={<SearchOrders />} />

      <Route path="/formulas" element={<Formulas />} />
      <Route path="/editHouseAgreement" element={<EditHouseAgreement />} />
      <Route path="/general" element={<General />} />
      <Route path="/allBanners" element={<AllBanners />} />
      <Route path="/printInvoices" element={<PrintInvoice />} />
      <Route path="/taxonomies" element={<Taxnomies />} />

      <Route path="/yourProfile" element={<YourProfile />} />
      <Route path="/updatePassword" element={<UpdatePassword />} />
    </Routes>
  );
}

export default App;
